/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AuthBeforeAuthUserCreate$Params {
  
    /**
     * Payload representing the blocking event triggered for user creation.
     */
    body: {

/**
 * The Firebase user record that is about to be created.
 */
'data'?: {

/**
 * The JWT token for the user.
 */
'jwt'?: string;
};
}
}

export function authBeforeAuthUserCreate(http: HttpClient, rootUrl: string, params: AuthBeforeAuthUserCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<{

/**
 * Modified or default display name.
 */
'displayName'?: string;

/**
 * Modified profile picture URL.
 */
'photoURL'?: string;

/**
 * Custom claims to persist with the user.
 */
'customClaims'?: {
};

/**
 * Updated email verification flag.
 */
'emailVerified'?: boolean;

/**
 * Updated disabled state.
 */
'disabled'?: boolean;
}>> {
  const rb = new RequestBuilder(rootUrl, authBeforeAuthUserCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      
      /**
       * Modified or default display name.
       */
      'displayName'?: string;
      
      /**
       * Modified profile picture URL.
       */
      'photoURL'?: string;
      
      /**
       * Custom claims to persist with the user.
       */
      'customClaims'?: {
      };
      
      /**
       * Updated email verification flag.
       */
      'emailVerified'?: boolean;
      
      /**
       * Updated disabled state.
       */
      'disabled'?: boolean;
      }>;
    })
  );
}

authBeforeAuthUserCreate.PATH = '/auth/beforeAuthUserCreate';
